import type React from "react";

import { type VerificationStepsEnum } from "../../lib/types/runtimeTypes";
import { ButtonType, type SingleSignOnMessages } from "../SingleSignOnComponent";

import { SSOPendingContentComponent } from "./SSOPendingContent";

interface SingleSignOnProps {
  stepName: VerificationStepsEnum.sso | VerificationStepsEnum.thirdPartyLoop;
  messages: SingleSignOnMessages;
  logo: React.ReactNode;
  cancelSingleSignOn: () => void;
  cancelButtonType?: ButtonType;
}

const SingleSignOnPending = ({
  stepName,
  messages,
  logo,
  cancelSingleSignOn,
  cancelButtonType = ButtonType.PRIMARY,
}: SingleSignOnProps) => (
  <SSOPendingContentComponent
    messages={messages}
    stepName={stepName}
    logo={logo}
    cancelSingleSignOn={cancelSingleSignOn}
    cancelButtonType={cancelButtonType}
  />
);

export const SingleSignOnPendingComponent = SingleSignOnPending;
